// [MCV-1542] Shared by the job-listing on-call form and the MSaaS shift-details
// form -- both submit-time handlers AND their recompute effects -- so none of
// those call sites can drift apart on wording for the same (allocated, total)
// pair.
export const buildShiftAllocationMessage = (allocated: number, total: number) =>
  `Allocated shifts must total ${total}. ${
    allocated > total ? `Remove ${allocated - total}.` : `Add ${total - allocated} more.`
  }`;
